import { render, staticRenderFns } from "./LiveScore.vue?vue&type=template&id=0f4c9537&scoped=true&"
import script from "./LiveScore.vue?vue&type=script&lang=js&"
export * from "./LiveScore.vue?vue&type=script&lang=js&"
import style0 from "./LiveScore.vue?vue&type=style&index=0&id=0f4c9537&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c9537",
  null
  
)

export default component.exports